import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'dottnet-snackbar',
    templateUrl: './extra-snackbar.component.html',
    styleUrls: ['./extra-snackbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ExtraSnackbarComponent {
	constructor(
		public snackBarRef: MatSnackBarRef<ExtraSnackbarComponent>,
		@Inject(MAT_SNACK_BAR_DATA) public data: any
	) {}
}
